module.exports = __webpack_public_path__ + "img/cover-home-page.5a7e5e80.png";